const VALID = 'valid';
const INVALID = 'error';
const UNPROCESSED = 'unprocessed';

const VALIDATION_STATES = [
  INVALID,
  VALID,
  UNPROCESSED,
];

const DEFAULT_VALIDATION_MESSAGE = {
  invalid: 'Please review the fields marked in red',
};

const DEFAULT_IS_EMPTY_VALIDATION_MESSAGE = 'must not be empty';

//ERROR CODE MESSAGE
const E_DATE_RANGE = 'No bank transactions in the expected date range';
const E_FILE_NO_PASSWORD = 'No password provided to open a password protected file';
const E_FILE_WRONG_PASSWORD = 'Wrong password provided to open a password protected file';
const E_OTHER = 'Some other error occurred';
const E_STATEMENT_UNSUPPORTED_FORMAT = 'Unsupported statement format';
const E_STATEMENT_WRONG_FORMAT = 'Wrong statement format';
const PERFIOS_ERROR_MESSAGE =
{
  E_AMOUNT_BALANCE_MISMATCH: "Calculated amounts/balances do not match actual values",
  E_API_SESSION_EXPIRED: "API session expired without the client taking any further action",
  E_DUPLICATE_STATEMENT: "User has uploaded duplicate statements",
  E_FILE_IO: "Cannot open uploaded file",
  E_FILE_NOT_STATEMENT: "Uploaded file is not a valid bank statement",
  E_FILE_UNSUPPORTED_FORMAT: "Unsupported file format",
  E_NOT_ACCEPTED: "Transaction did not meet the criteria set by acceptance policy",
  E_NO_ERROR: "No errors",
  E_STATEMENT_ERRONEOUS_DATA: "Statement contains erroneous data",
  E_STATEMENT_NO_TRANSACTIONS: "Statement contains no transactions",
  E_STATEMENT_WRONG_INSTITUTION: "User uploaded statement for wrong institution",
  E_STATEMENT_UNSUPPORTED_INSTITUTION: "User uploaded statement for an institution not supported by Perfios",
  E_SYSTEM: "System (Perfios) error",
  E_DATE_RANGE: "No bank transactions in the expected date range",
  E_FILE_NO_PASSWORD: "No password provided to open a password protected file",
  E_FILE_WRONG_PASSWORD: "Wrong password provided to open a password protected file",
  E_OTHER: "Some other error occurred",
  E_STATEMENT_UNSUPPORTED_FORMAT: "Unsupported statement format",
  E_STATEMENT_WRONG_FORMAT: "Wrong statement format",
};

export {
  INVALID,
  VALID,
  VALIDATION_STATES,
  UNPROCESSED,
  DEFAULT_VALIDATION_MESSAGE,
  DEFAULT_IS_EMPTY_VALIDATION_MESSAGE,
  E_DATE_RANGE,
  E_FILE_NO_PASSWORD,
  E_FILE_WRONG_PASSWORD,
  E_OTHER,
  E_STATEMENT_UNSUPPORTED_FORMAT,
  E_STATEMENT_WRONG_FORMAT,
  PERFIOS_ERROR_MESSAGE
};
